import { gql } from 'graphql-request';

export const SEND_EMAIL_TO_AUTHORITY = gql`
  mutation CorePOA($email: String!, $cert: String!) {
    corePOA {
      sendPOANotificationToAuthority(email: $email, cert: $cert)
    }
  }
`;
